import Api from '../../api/Api'

const webinar = {
  //set namespace true
  namespaced: true,

  //state
  state: {
    webinar: [],
    webinar_transaksi: [],
    enrolled: [],
    info_overview: {},
    edit_webinar: {},
    empty: '',
  },

  //mutations
  mutations: {
    SET_WEBINAR(state, webinar) {
      state.webinar = webinar
    },
    SET_WEBINAR_TRANSAKSI(state, webinar_transaksi) {
      state.webinar_transaksi = webinar_transaksi
    },
    SET_ENROLLED(state, enrolled) {
      state.enrolled = []
      state.enrolled = enrolled
    },
    SET_INFO_OVERVIEW(state, info_overview) {
      state.info_overview = info_overview
    },
    SET_EDIT_WEBINAR(state, edit) {
      state.edit_webinar = edit
    },
    EMPTY(state, string) {
      state.empty = string
    },
  },

  //actions
  actions: {
    create_webinar({ commit }, user) {
      return new Promise((resolve, reject) => {
        Api.post('admin/webinar/create', user, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    ubah_status_sertifikat_user({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.post(`admin/webinar/changeSertif/${data.id_aktifitas}`, data)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    ubah_status_materi_user({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.post(`admin/webinar/changeMateri/${data.id_aktifitas}`, data)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    incrementView({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.post('/add_view_webinar', {
          id_event: data.id_event,
        })
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    kirim_survey({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.post('/admin/webinar/isi_survey', data)
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    webinar_highlight() {
      return new Promise((resolve, reject) => {
        Api.get('/webinar_highlight')
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getWebinar({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.get(
          `/get_webinar?event=${data.event}&search=${data.search}&tags=${data.tags}&level=${data.level}&waktu=${data.waktu}&jenis_produk=${data.jenis_produk}`,
        )
          .then((response) => {
            commit('EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error.response)
          })
      })
    },
    highlight({ commit }) {
      return new Promise((resolve, reject) => {
        Api.get(`/highlight`)
          .then((response) => {
            commit('EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error.response)
          })
      })
    },
    admin_list_webinar_aktif({ commit }, user) {
      return new Promise((resolve, reject) => {
        Api.get(
          `/admin/webinar?page=${user.page}&per_page=${user.per_page}&status=${user.status}&start=${user.start}&end=${user.end}&search=${user.search}&topik=${user.topik}`,
        )
          .then((response) => {
            commit('SET_WEBINAR', response.data.data.data)
            resolve(response.data.data)
          })
          .catch((error) => {
            reject(error.response)
          })
      })
    },
    admin_list_webinar_nonaktif({ commit }, user) {
      return new Promise((resolve, reject) => {
        Api.get(
          `/admin/webinar?page=${user.page}&per_page=${user.per_page}&status=${user.status}`,
        )
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error.response)
          })
      })
    },
    transaksi_webinar({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.get(
          `/admin/webinar/transaksi?id_webinar=${data.id_webinar}&is_sertifikat=${data.is_sertifikat}&is_materi=${data.is_materi}&search=${data.search}&page=${data.page}&per_page=${data.per_page}&status=${data.status}&jenis_pembelian=${data.jenis_pembelian}&payment=${data.sumber_dana}`,
        )
          .then((response) => {
            commit('SET_WEBINAR_TRANSAKSI', response.data.data.data)
            resolve(response.data.data)
          })
          .catch((error) => {
            reject(error.response)
          })
      })
    },
    detail_overview({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.get(
          `/admin/webinar/analytic_overview/${data.id_webinar}?is_sertifikat=${data.is_sertifikat}&is_materi=${data.is_materi}&page=${data.page}&per_page=${data.per_page}&search=${data.search}`,
        )
          .then((response) => {
            commit('SET_INFO_OVERVIEW', response.data.data.info)
            commit('SET_ENROLLED', response.data.data.enrolled.data)
            resolve(response.data.data.enrolled)
          })
          .catch((error) => {
            reject(error.response)
          })
      })
    },
    detail_webinar({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.get(`/get_webinar/${params.id_event}`)
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    update_webinar({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.post(`/admin/webinar/update_webinar`, params)
          .then((response) => {
            commit('EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    webinar_to_workshop({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.post(`/admin/webinar/webinar_to_workshop`, params)
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    detail_webinar_landing({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.get(`/get_webinar_detail/${params.id_event}`)
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    admin_cms_detail({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.get(`/admin/webinar/detail_webinar_cms/${params.id_event}`)
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    admin_cms_analytic({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.get(`/admin/webinar/analytic/${params.id_event}`)
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    feedback_webinar({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.get(
          `/admin/webinar/feedback_webinar/${params.id_event}?page=${params.page}&per_page=${params.per_page}&search=${params.search}`,
        )
          .then((response) => {
            commit('')
            resolve(response.data.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    detail_webinar_landing_short({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.get(`/webinarByKode/${params.id_event}`)
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    admin_detail({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.get(`/admin/webinar/detail/${params.id}`)
          .then((response) => {
            commit('SET_EDIT_WEBINAR', response.data.data)
            resolve(response.data.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    list_user({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.get(
          `/admin/webinar/getUser?email=${params.query}&fullname=${params.query}`,
        )
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    hapus_webinar({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.post(`/admin/webinar/hapus_webinar`, params)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    hapus_peserta_enrolled({}, params) {
      return new Promise((resolve, reject) => {
        Api.post(`/admin/webinar/delete_enrolled`, {
          user: params.user,
        })
          .then((response) => {
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    export_enrolled({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.get(`/admin/webinar/export_enrolled/${params.id_event}`, {
          responseType: 'blob',
        })
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    export_transaksi_webinar({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.get(`/admin/webinar/export_transaction/${params.id_event}`, {
          responseType: 'blob',
        })
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    exportSurvey({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.get(
          `/admin/webinar/export_survey/${params.id_event}?id_batch=${params.id_batch}`,
          { responseType: 'blob' },
        )
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    export_saran({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.get(`/admin/webinar/export_saran/${params.id_event}`, {
          responseType: 'blob',
        })
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    aktifasi_webinar({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.post(`/admin/webinar/aktif_webinar`, params)
          .then((response) => {
            commit('EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    nonaktif_webinar({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.post(`/admin/webinar/nonaktif_webinar`, params)
          .then((response) => {
            commit('EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
  },

  //getters
  getters: {
    getWebinar(state) {
      return state.webinar
    },
    getWebinarTransaksi(state) {
      return state.webinar_transaksi
    },
    getInfoOverview(state) {
      return state.info_overview
    },
    getEnrolled(state) {
      return state.enrolled
    },
    getEditWebinar(state) {
      return state.edit_webinar
    },
  },
}

export default webinar
